<template>
  <div class="load-more-container">
    <b-container>
      <div>
        <div class="ft-notification">
          <b-row>
            <div class="alert-col">
              <b-alert
                show
                variant="warning"
                class="ft-alert"
                style="
                  display: flex;
                  flex-direction: row;
                  align-items: flex-start;
                "
              >
                <div
                  class="alert-content"
                  style="
                    width: 50%;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    overflow: hidden;
                  "
                >
                  <p>
                    {{
                      $t("message.banner.bannerActiveText", [getSupplierName])
                    }}
                  </p>
                </div>
                <div style="position: absolute; right: 1rem">
                  <add-supplier-modal />
                </div>
              </b-alert>
            </div>
          </b-row>
          <!-- <status-banner :data="{demand_status_details: 'OPEN', supplier_name: getSupplierName}"/> -->
        </div>
      </div>
    </b-container>
    <b-container style="padding: 1rem">
      <b-button-group class="from-to-btn-group" style="width: 100%">
        <b-button
          variant="outline-secondary"
          block
          style="width: 50%; height: 48px; background: #fff"
          @click="onAddRoute"
        >
          <b-row style="margin-top: -6px">
            <b-col cols="1" style="height: 48px">
              <b-icon
                icon="square-fill"
                variant="info"
                font-scale="0.5"
              ></b-icon>
            </b-col>
            <b-col cols="9" style="height: 48px; margin-left: -10px">
              <!-- <b-form-text class="title-text"> {{ $t('message.from_title') }} </b-form-text> -->
              <b-form-text
                class="route-text"
                v-if="origin !== ''"
                style="margin-top: 0.5rem"
              >
                {{ origin }}
              </b-form-text>
              <b-form-text
                class="placeholder-text"
                v-if="origin === ''"
                style="margin-top: 0.5rem"
              >
                {{ $t("message.loadig_city") }}
              </b-form-text>
            </b-col>
          </b-row>
        </b-button>
        <b-button
          variant="outline-secondary"
          style="width: 50%; height: 48px; background: #fff"
          @click="onAddRoute"
        >
          <b-row style="margin-top: -6px">
            <b-col cols="1" style="height: 48px">
              <b-icon
                icon="square-fill"
                variant="secondary"
                font-scale="0.5"
              ></b-icon>
            </b-col>
            <b-col cols="9" style="height: 48px; margin-left: -10px">
              <!-- <b-form-text class="title-text"> {{ $t('message.to_title') }} </b-form-text> -->
              <b-form-text
                class="route-text"
                v-if="destination !== ''"
                style="margin-top: 0.5rem"
              >
                {{ destination }}
              </b-form-text>
              <b-form-text
                class="placeholder-text"
                v-if="destination === ''"
                style="margin-top: 0.5rem"
              >
                {{ $t("message.unLoading_city") }}
              </b-form-text>
            </b-col>
          </b-row>
        </b-button>
      </b-button-group>
      <RouteModal
        @add-route="add_Route"
        :routes_list="routes_list"
        type="multiple"
      />
    </b-container>
    <b-container class="demand-details-container">
      <DemandDetailsCard
        v-for="(demand, idx) in demandDetails"
        v-bind:key="idx"
        :item="demand"
        @click-bid-now="openDemandDetailsModal"
      />
      <div
        v-if="demandDetails.length"
        v-observe-visibility="getMoreDemandList"
      ></div>
      <div style="text-align: center" v-if="showPageLoader">
        <b-spinner
          style="width: 3rem; height: 3rem"
          label="Large Spinner"
        ></b-spinner>
      </div>
      <div class="no-more-loads" v-if="noMoreLoadsMsg">
        <span>{{ $t("message.noMoreLoadsText") }}</span>
      </div>
      <div
        v-if="demandDetails.length === 0 && !showPageLoader"
        style="margin-top: 20%"
      >
        <NoresultsFound route="load_market" />
      </div>
      <b-row
        v-if="demandDetails.length === 0 && !showPageLoader"
        class="btn-fixed-bottom-route"
        style="position: relative"
      >
        <b-col>
          <b-button
            type="submit"
            variant="outline-dark"
            block
            @click="truckAvailability"
          >
            {{ $t("message.haveTrucksAlert") }}
          </b-button>
        </b-col>
      </b-row>
    </b-container>
    <DemandDetailsModal
      :item="currentItem"
      @update-demand-list="updateDemandStatus"
    />
  </div>
</template>
<script>
import RouteModal from "../components/modals/LoadRouteModal.vue";
import DemandDetailsCard from "../components/DemandDetailsCard.vue";
import DemandDetailsModal from "../components/modals/DemandDetailsModal.vue";
import NoresultsFound from "../components/modals/NoresultsFound.vue";
// import StatusBanner from '../components/StatusBanner.vue'
import AddSupplierModal from "../components/AddSupplierModal.vue";

import axios from "axios";
import { MX_TRACK } from "../utils/Mixpanel.js";
const Hotjar = require("../utils/Hotjar.js");

import config from "../config/config.js";

const API_BASE_URL = process.env.VUE_APP_API_GATEWAY_BASE_URL;

export default {
  name: "LoadMore",
  components: {
    RouteModal,
    DemandDetailsCard,
    DemandDetailsModal,
    NoresultsFound,
    // StatusBanner,
    AddSupplierModal,
  },
  data() {
    return {
      showRouteModal: false,
      showLoader: false,
      routes_list: [],
      routes_dup: {},
      showSaveBtnLoader: false,
      showPageLoader: true,
      origin: "",
      destination: "",
      demandDetail: {},
      demandDetails: [],
      currentItem: {},
      pagination: {
        total: 0,
        pageSize: 15,
        currentPage: 0,
        searchAfter: null,
      },
      pageSize: 15,
      currentPage: 0,
      noMoreLoadsMsg: false,
    };
  },
  methods: {
    truckAvailability() {
      //this.trackMixpanelEvent(config.MIXPANEL_EVENTS.ON_CLICK_TRUCK_AVAILABILITY)
      this.$router.push(
        `/${this.$route.params.lang}/truck_availability/${this.$route.params.id}`
      );
    },
    async onAddRoute() {
      console.log("ON_CLICK_ROUTE");
      this.$root.$emit("on-add-route", null);
    },
    add_Route(route) {
      this.routes_list = route;
      this.routes_dup = route;
      this.origin = route.origin;
      this.destination = route.destination;
      this.demandDetails = [];
      this.currentPage = 0;
      this.pagination = {
        total: 0,
        pageSize: 15,
        currentPage: 0,
        searchAfter: null,
      };
      //
      const mxData = {
        origin: route.origin,
        destination: route.destination,
      };
      this.trackMixpanelEvent(
        config.MIXPANEL_EVENTS.LOAD_MARKET_ROUTE_SEARCH_DONE,
        mxData
      );
      //
      this.getDemadDetails();
      //
    },
    getMoreDemandList(isVisible) {
      if (isVisible) {
        if (this.demandDetails.length < this.pagination.total) {
          this.currentPage += 1;
          this.showPageLoader = true;
          this.getDemadDetails();
        } else {
          this.noMoreLoadsMsg = true;
        }
      }
    },
    openDemandDetailsModal(item) {
      this.currentItem = item;
      this.$bvModal.show("ft-demand-details-modal");
      //
      let mx_prop = {};
      let eventName = "";
      if (item.demand_status_details.is_edit_allowed) {
        mx_prop = {
          original_bid: item.demand_status_details.rate,
          previous_bid: item.demand_status_details.rate,
          lowest_bid: item.demand_status_details.lowest_bid.rate,
          demand_status: item.demand_status_details.status,
        };
        eventName = config.MIXPANEL_EVENTS.EDIT_BID_ON_CLICK_EDIT_RATE_BUTTON;
      } else {
        mx_prop = {
          user_type: item.user_type,
          user_name: item.supplier_name,
          phone_number: item.contact,
          language: this.$route.params.lang,
          demand_id: item.demand_id,
          demand_status: item.demand_status,
          bid_status: item.status,
          time: new Date().getTime(),
          user_id: item.supplier_id,
          page_src: this.$route.name,
          vehicle_count: item.trucks_required,
          template: this.$route.params.template || "",
        };
        eventName = config.MIXPANEL_EVENTS.PAGE_LOAD;
      }

      Hotjar.IDENTIFY_FO_APP(this, item.supplier_id, mx_prop);

      MX_TRACK(eventName, mx_prop);
    },
    async getDemadDetails(isDefault = false) {
      try {
        const pageNo = isDefault ? 0 : this.currentPage;
        // const {data} = await axios.get(`${API_BASE_URL}/supplier/${this.$route.params.id}/load_market?page=${pageNo}&size=${this.pageSize}`)
        let url = `${API_BASE_URL}/supplier/load_market?page=${pageNo}&size=${this.pageSize}&unique_id=${this.$route.params.id}`;
        if (this.origin !== "") {
          url =
            url +
            `&origin_place_id=${this.routes_list.origin_place_id}&origin_label=${this.routes_list.origin}`;
        }
        if (this.destination !== "") {
          url =
            url +
            `&destination_place_id=${this.routes_list.destination_place_id}&destination_label=${this.routes_list.destination}`;
        }

        const { data } = await axios.get(url);
        this.pagination = data.pagination;
        // data.value[0].demand_status_details = {status: "OPEN", rate: 1222, trucks_supplied: 1, winning_bid: null}

        this.demandDetails = isDefault
          ? data.value
          : [...this.demandDetails, ...data.value];
      } catch (error) {
        console.log(error);
      }
      this.showPageLoader = false;
    },
    updateDemandStatus(id, data) {
      const demands = [...this.demandDetails];
      demands.find((demand, idx) => {
        if (demand.unique_id == id) {
          demands[idx].demand_status_details = data.value;
          return;
        }
      });
      this.demands = demands;
    },
    trackMixpanelEvent(event, data = {}) {
      const demandDetails = this.$store.getters.getDemandDetails.value;
      const mx_prop = {
        time: new Date().getTime(),
        page_src: this.$route.name,
        user_type: demandDetails.user_type,
        user_name: demandDetails.supplier_name,
        phone_number: demandDetails.contact,
        language: this.$route.params.lang,
        demand_id: demandDetails.demand_id,
        bid_status: demandDetails.status,
      };
      MX_TRACK(event, { ...mx_prop, ...data });
    },
    cacheId() {
      localStorage.setItem("demand_supply_id", this.$route.params.id);
    },
  },
  mounted() {
    this.getDemadDetails(true);
    this.cacheId();
    const routeData = {
      routeName: this.$route.name,
      lng: this.$route.params.lang,
      demandId: this.$route.params.id,
    };
    this.$store.dispatch("swWorkerInitialized", routeData);
  },
  watch: {
    "$store.state.demandDetails": {
      immediate: true,
      handler() {
        this.demandDetail = this.$store.getters.getDemandDetails;
      },
    },
  },
  computed: {
    getSupplierName() {
      return this.demandDetail.value.supplier_name;
    },
  },
};
</script>

<style lang="scss">
.load-more-container {
  background-color: #e5e5e5;
  min-height: 500px;
}

.load-more-container {
  margin-top: 80px;
  height: 100%;
}

.ui-confirmdialog-message {
  white-space: pre-line;
}

.btn-fixed-bottom-route {
  margin-bottom: 10px;
}
.btn-outline-dark {
  /* color: #343a40; */
  color: #3094fc;
}
// .btn-fixed-bottom {
//             position: fixed;
//             bottom: 0;
//             width: 100%;
//             background-color: white;
//             z-index: 5;
//             padding-top:20px;
//             padding-bottom:20px;
//             margin-bottom: 0px;
//         }
// .alert-content {
//   width: 50%;
//   text-overflow: ellipsis;
//   white-space: nowrap;
//   overflow: hidden;
// }
@media (max-width: 576px) {
  .demand-details-container {
    padding: 0;
    overflow-y: auto;
    // min-height:750px;
    // max-height: 850px;
    height: 100vh;
    padding-bottom: 50px;
  }

  .load-more-container {
    margin-top: 66px;
    // margin-bottom: 100px;
  }

  .btn-fixed-bottom-route {
    position: fixed;
    bottom: 0;
    width: 100%;
    // align-self: center;
    margin-left: 1.5%;
    //background-color: white;
    z-index: 5;
    padding-top: 20px;
    padding-bottom: 20px;
    margin-bottom: 0px;
  }
  // margin-bottom: 10px;
}
.route-text {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: start;
}
.placeholder-text {
  text-align: left;
}
.title-text {
  text-align: left;
}
</style>
